import React from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import courseHero from "../assets/courses-tech.jpg"; // Import the local image

import courses from "../data/courses.json";
import "./CourseDetails.css";

function CourseDetail() {
  const { id } = useParams();
  const course = courses.find((c) => c.id === id);

  if (!course) {
    return (
      <>
        <Navbar />
        <div className="course-detail-notfound">
          <h2>Course Not Found</h2>
          <Link to="/ittech" className="cta-btn">Back to Courses</Link>
        </div>
        <Footer />
      </>
    );
  }

  const commonModules = [
    "Soft Skills",
    "Interview Preparation",
    "Communication Skills",
    "Professional Ethics",
  ];

  return (
    <>
      <Navbar />

      {/* HERO */}
      
<section
  className="course-detail-hero"
  style={{
    backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${courseHero})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="hero-content">
    <h1>{course.title}</h1>
    <p>{course.description}</p>
    <div className="hero-info">
      <span>Duration: {course.duration}</span>
      <span>Technologies: {course.technologies.join(", ")}</span>
    </div>
    <Link to="/contact" className="enroll-btn">Enroll Now</Link>
  </div>
</section>



      {/* COURSE HIGHLIGHTS */}
      <section className="course-highlights">
        <h2>Course Highlights</h2>
        <div className="highlights-grid">
          <div className="highlight-card">
            <h3>Duration</h3>
            <p>{course.duration}</p>
          </div>
          <div className="highlight-card">
            <h3>Level</h3>
            <p>Beginner to Advanced</p>
          </div>
          <div className="highlight-card">
            <h3>Technologies</h3>
            <p>{course.technologies.join(", ")}</p>
          </div>
          <div className="highlight-card">
            <h3>Projects</h3>
            <p>Hands-on real-world projects</p>
          </div>
        </div>
      </section>

      {/* SYLLABUS */}
      <section className="course-syllabus">
        <h2>Detailed Syllabus</h2>
        <div className="syllabus-grid">
          {course.subjects.map((subject, idx) => (
            <div key={idx} className="syllabus-card">
              <span>{idx + 1}</span> {subject}
            </div>
          ))}
        </div>
      </section>

      {/* PROFESSIONAL MODULES */}
      <section className="course-professional">
        <h2>Professional Skills Included</h2>
        <div className="professional-grid">
          {commonModules.map((mod, idx) => (
            <div key={idx} className="professional-card">{mod}</div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="course-cta">
        <h2>Take the Next Step in Your Career</h2>
        <p>Enroll in <strong>{course.title}</strong> and start building your future today.</p>
        <Link to="/contact" className="cta-btn">Enroll Now</Link>
      </section>

      <Footer />
    </>
  );
}

export default CourseDetail;
